export default {
  metadata: {
    version: '1.0.0',
    id: 'table-body-1.0.0',
    name: 'JDSTableBody'
  },
  hierarchy: {
    container: ['jds_table_row']
  },
  base: {
    container: {
      'flex-direction': '{t_1}'
    },
    jds_table_row: {}
  },
  variant: {
    density: {
      condensed: {
        jds_table_row: {
          density: 'condensed'
        }
      }
    },
    fullWidth: {
      true: {
        container: {
          width: '{t_2}'
        },
        jds_table_row: {
          flex: 1
        }
      }
    },
    columnDivider: {
      true: {
        jds_table_row: {
          columnDivider: true
        }
      }
    }
  },
  api: {
    config: {
      density: {
        type: 'JDSTableCell.density',
        values: ['relaxed', 'condensed']
      },
      columnDivider: {
        values: [false, true],
        function: true
      },
      fullWidth: {
        values: [false, true]
      },
      zebra: {
        values: [false, true]
      }
    },
    data: {
      container: {
        value: {
          type: 'list',
          name: 'rows',
          function: true,
          object: {
            cells: 'JDSTableRow.cells'
          }
        }
      },
      jds_table_row: {
        cells: {
          name: 'rows.cells',
          type: 'list'
        }
      }
    }
  }
};
